export enum RegisterSaleErrorTypeEnum {
    SALE,
    PRINT
}